import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface CareItem {
  category: string;
  icon: string;
  level: 'Low' | 'Medium' | 'High';
  details: string;
}

interface CareRequirementsProps {
  careItems: CareItem[];
  dietaryNeeds: string;
  exerciseNeeds: string;
  groomingNeeds: string;
}

const CareRequirements = ({
  careItems,
  dietaryNeeds,
  exerciseNeeds,
  groomingNeeds,
}: CareRequirementsProps) => {
  const levelColors = {
    Low: 'bg-success/10 text-success',
    Medium: 'bg-warning/10 text-warning',
    High: 'bg-error/10 text-error',
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-headline font-semibold text-foreground mb-4">
          Care Requirements
        </h2>
        <div className="grid md:grid-cols-2 gap-4">
          {careItems.map((item, index) => (
            <div key={index} className="p-4 bg-card rounded-xl border border-border">
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <Icon name={item.icon as any} size={24} variant="outline" className="text-primary" />
                  </div>
                  <h3 className="text-lg font-body font-semibold text-foreground">
                    {item.category}
                  </h3>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-sm font-body font-medium ${
                    levelColors[item.level]
                  }`}
                >
                  {item.level}
                </span>
              </div>
              <p className="text-sm text-muted-foreground font-body">{item.details}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <div className="p-6 bg-card rounded-xl border border-border">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="CakeIcon" size={24} variant="outline" className="text-primary" />
            <h3 className="text-lg font-body font-semibold text-foreground">Dietary Needs</h3>
          </div>
          <p className="text-base text-foreground font-body leading-relaxed">{dietaryNeeds}</p>
        </div>

        <div className="p-6 bg-card rounded-xl border border-border">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="BoltIcon" size={24} variant="outline" className="text-primary" />
            <h3 className="text-lg font-body font-semibold text-foreground">Exercise Needs</h3>
          </div>
          <p className="text-base text-foreground font-body leading-relaxed">{exerciseNeeds}</p>
        </div>

        <div className="p-6 bg-card rounded-xl border border-border">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="SparklesIcon" size={24} variant="outline" className="text-primary" />
            <h3 className="text-lg font-body font-semibold text-foreground">Grooming Needs</h3>
          </div>
          <p className="text-base text-foreground font-body leading-relaxed">{groomingNeeds}</p>
        </div>
      </div>
    </div>
  );
};

export default CareRequirements;